import { render, staticRenderFns } from "./AphtAdd.vue?vue&type=template&id=63d0daba&"
import script from "./AphtAdd.vue?vue&type=script&lang=js&"
export * from "./AphtAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports